'use es6';

import { MYSQL } from 'DesignData/enums/AssetSources';
import { formatPathAsId } from 'DesignData/lib/text';
import { getRootFolderId } from 'DesignData/selectors/finder';
import { CUSTOM_WIDGET } from 'DesignData/enums/DesignAssetTypes';
/**
 * If an asset is not `assetSource == MYSQL` then:
 *  - Try to copy `id` to `legacyId`
 *  - Try to format `path` as the new `id`
 *
 * @param {Number|String} assetId
 * @param {Object}        asset
 * @param {Function}      getState
 * @returns {Object}
 */

export function transformIdsForNonMysqlResource(assetType, assetId, asset, getState = null) {
  const {
    assetSource
  } = asset;
  const isNonMySql = assetSource && assetSource !== MYSQL;
  let id = assetId;
  let legacyId = null;
  let folderId = asset.folderId || null;
  let name = asset.name;

  if (isNonMySql) {
    // legacyId
    if (asset.id && asset.id !== -1) {
      legacyId = asset.id;
    } // id


    if (asset.path) {
      id = formatPathAsId(asset.path);
    }

    if (assetType === CUSTOM_WIDGET) {
      if (!asset.name.endsWith('.module')) {
        const parts = asset.path.split('/');
        const filename = parts.pop();
        name = `${filename}.module`;
      }
    } // folderId


    if (asset.folderPath) {
      folderId = formatPathAsId(asset.folderPath);
    } else if (asset.folder && typeof asset.folder === 'string') {
      // `folder` is a boolean flag in some objects
      folderId = formatPathAsId(asset.folder);
    } else if (asset.path) {
      const parts = asset.path.split('/');
      parts.pop();
      const folderPath = parts.join('/') || '/';

      if (folderPath === '/') {
        folderId = getState ? getRootFolderId(getState()) : formatPathAsId(folderPath);
      } else {
        folderId = formatPathAsId(folderPath);
      }
    }
  }

  return Object.assign({}, asset, {}, name ? {
    name
  } : {}, {
    folderId,
    legacyId,
    id
  });
}